import { render, staticRenderFns } from "./SaveAsModal.vue?vue&type=template&id=bbc3194a"
import script from "./SaveAsModal.vue?vue&type=script&lang=ts"
export * from "./SaveAsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbc3194a')) {
      api.createRecord('bbc3194a', component.options)
    } else {
      api.reload('bbc3194a', component.options)
    }
    module.hot.accept("./SaveAsModal.vue?vue&type=template&id=bbc3194a", function () {
      api.rerender('bbc3194a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SaveAsModal.vue"
export default component.exports